import React from 'react';
import { FormattedMessage } from 'react-intl';
import css from './TableStates.css';
import { useSlowQueryNotice } from './useSlowQueryNotice';
/**
 * CZNA-538 — the refetch case: the table already has rows, and a new query is running.
 *
 * The rows on screen belong to the *previous* query (react-query `keepPreviousData`),
 * so they are neither the answer nor nothing — and MCL's own `loading` indicator, a
 * dot spinner inside the paging button below the list (`PagingButton.js`), is the
 * "three dots in the corner" this ticket is about. A scrim over the table says the
 * same thing where the user is already looking, without removing the rows — which
 * would collapse the pane's height and make the screen jump.
 */
var TableRefetchOverlay = function (_a) {
    var active = _a.active, children = _a.children, _b = _a.testId, testId = _b === void 0 ? 'table-refetch-overlay' : _b;
    var isSlow = useSlowQueryNotice(active);
    return (React.createElement("div", { className: css.overlayWrap, "aria-busy": active || undefined },
        children,
        active && (React.createElement("div", { className: css.overlayScrim, "data-testid": testId },
            React.createElement("div", { className: css.overlayPill, role: "status" },
                React.createElement("span", { className: css.spinnerDot, "aria-hidden": "true" }),
                React.createElement("span", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.tableStates.loading" }),
                    isSlow && (React.createElement("span", { className: css.overlayNote, "data-testid": "".concat(testId, "-slow") },
                        React.createElement(FormattedMessage, { id: "ui-czna-authorities.tableStates.stillLoading" })))))))));
};
export default TableRefetchOverlay;
